import axios, { AxiosRequestConfig } from "axios";

export class CDNUtils {
	static getAbsoluteCDNURL(cdnFilePath: string): string {
		const fullUrl = new URL(`/static${cdnFilePath}`, "https://www.example.com");
		return fullUrl.pathname;
	}

	static async loadFileFromCDN<T = any>(cdnFilePath: string, disableCache: boolean = false): Promise<T> {
		const config: AxiosRequestConfig = {};

		if (disableCache) {
			config.headers = {
				"Cache-Control": "no-cache",
				"Pragma": "no-cache",
				"Expires": "0"
			};
		}

		return (await axios.get(CDNUtils.getAbsoluteCDNURL(cdnFilePath), config)).data;
	}
}
